export const assignLabelToContactCopy = {
  header: '',
  description: '',
  successToast: '',
};
